import { render } from "./SidebarInfo.vue?vue&type=template&id=6c76b4be"
import script from "./SidebarInfo.vue?vue&type=script&lang=js"
export * from "./SidebarInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__